import React from 'react'
export default () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#fff" fillRule="evenodd">
      <circle stroke="#666" cx="14" cy="14" r="13.5" />
      <circle fill="#666" cx="14" cy="14" r="5" />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/stepIcon.js